<template>
	<div class="home">
		<question-container />

	</div>
</template>

<script>
	import QuestionContainer from '@/components/questions/QuestionContainer';

	export default {
		name: 'Home',
		components: {
			QuestionContainer
		},
	}
</script>

<style lang="scss" scoped>
</style>
